@if (!embedded) {
  <div class="dc-modal verify-email-modal">
    <div class="dc-modal-container max-w-[500px]!">
      <!-- <button class="modal-x-button" type="button" (click)="otpModal = false">
        <i class="fas fa-close"></i>
      </button> -->
      <div class="">
        <h1 class="text-xl font-semibold text-dc-navy! mb-2">{{ "VERIFY.TITLE" | translate }}</h1>

        <div class="modal-body-content pt-3">
          <!-- <p class="!text-sm text-dc-navy!">{{ "VERIFY.SUBTITLE_1" | translate }}</p> -->
          <p class="!text-sm text-dc-navy!">{{ "VERIFY.SUBTITLE_2" | translate }}</p>

          <div class="field-control mt-4">
            <app-text-field
              [label]="'VERIFY.OTP_PLACEHOLDER' | translate"
              [placeholder]="'VERIFY.OTP_PLACEHOLDER' | translate"
              [control]="otpForm.get('otp')!"
              [maxlength]="6"
            />
            @if (verifyErrorMessage) {
              <div class="fields-error-container text-left mt-1">
                @if (verifyErrorIsKey) {
                  {{ verifyErrorMessage === 'TECHNICAL_ERROR' ? ('TECHNICAL_ERROR' | translate) : ('VERIFY.INVALID_OTP' | translate) }}
                } @else {
                  {{ verifyErrorMessage }}
                }
              </div>
            }
          </div>

          <div class="flex gap-3 justify-center">
            @if(!loading){
            <app-button
              type="button"
              classesName="verify-pill-btn w-full"
              [label]="'VERIFY.SUBMIT' | translate"
              (onBtnClick)="verifyOtp()"
            ></app-button>

            <app-button
              type="button"
              [classesName]="
                resendCountdown > 0
                  ? 'card-edge-cut-white opacity-50 pointer-events-none'
                  : 'card-edge-cut-white'
              "
              [label]="'VERIFY.RESEND' | translate"
              (onBtnClick)="resendOtp()"
            ></app-button>
            }
            @else {
              <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
            }
          </div>
          @if (resendCountdown > 0) {
            <div class="text-sm text-dc-navy mt-3 text-center">
              {{ "VERIFY.RESEND_IN" | translate : { time: resendTimeDisplay } }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="w-full">
    <div class="flex items-start gap-3 flex-nowrap">
      <div class="field-control1 flex-1 min-w-0">
        <app-text-field
          [label]="'VERIFY.OTP_PLACEHOLDER' | translate"
          [placeholder]="'VERIFY.OTP_PLACEHOLDER' | translate"
          [control]="otpForm.get('otp')!"
          [maxlength]="6"
        />
        @if (verifyErrorMessage) {
          <div class="fields-error-container text-left mt-1">
            @if (verifyErrorIsKey) {
              {{ verifyErrorMessage === 'TECHNICAL_ERROR' ? ('TECHNICAL_ERROR' | translate) : ('VERIFY.INVALID_OTP' | translate) }}
            } @else {
              {{ verifyErrorMessage }}
            }
          </div>
        }
      </div>

      @if(!loading){
      <div class="flex items-stretch gap-3 shrink-0 pt-[25px]">
        <app-button
          type="button"
          classesName="verify-pill-btn shrink-0 min-h-[45px] px-6 py-0 text-base leading-none"
          [label]="'VERIFY.SUBMIT' | translate"
          (onBtnClick)="verifyOtp()"
        ></app-button>

        <app-button
          type="button"
          [classesName]="
            resendCountdown > 0
              ? 'card-edge-cut-white shrink-0 min-h-[45px] px-6 py-0 text-base leading-none opacity-50 pointer-events-none'
              : 'card-edge-cut-white shrink-0 min-h-[45px] px-6 py-0 text-base leading-none'
          "
          [label]="'VERIFY.RESEND' | translate"
          (onBtnClick)="resendOtp()"
        ></app-button>
      </div>
      }
      @else {
        <div class="pt-[28px] shrink-0">
          <app-skeleton-loader [pingLoder]="true"></app-skeleton-loader>
        </div>
      }
    </div>

    @if (resendCountdown > 0) {
      <div class="text-sm text-dc-navy">
        {{ "VERIFY.RESEND_IN" | translate : { time: resendTimeDisplay } }}
      </div>
    }
  </div>
}
